import React from 'react';
import { SettingsLayout } from '../../../../design-system/components/layouts';
import { PageHeader } from '../../../../design-system/components';
import { admin_settings_webhook_path } from '../../../../lib/routes';
import WebhookForm from './Form';
export default function Edit({ webhook, supported_events }) {
  return (
    <SettingsLayout>
      <PageHeader title="Edit Webhook Endpoint" description={webhook.url} />

      <div className="mt-6">
        <WebhookForm
          webhook={webhook}
          action={admin_settings_webhook_path(webhook.id)}
          method="patch"
          supported_events={supported_events}
        />
      </div>
    </SettingsLayout>
  );
}
